import { render, staticRenderFns } from "./echartsRadar2.vue?vue&type=template&id=86c1ae38&scoped=true"
import script from "./echartsRadar2.vue?vue&type=script&lang=js"
export * from "./echartsRadar2.vue?vue&type=script&lang=js"
import style0 from "./echartsRadar2.vue?vue&type=style&index=0&id=86c1ae38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c1ae38",
  null
  
)

export default component.exports